import React from "react";
import { Link } from "react-router-dom";
import logo from "../assets/logo.png";

export default function Footer() {
    return (
        <footer className="bg-[#1a1f2e] border-t border-white/5 pt-16 pb-8 mt-auto text-gray-400">
            <div className="max-w-7xl mx-auto px-6">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
                    {/* Brand and Info */}
                    <div className="col-span-1 md:col-span-1">
                        <div className="flex items-center gap-2 mb-4">
                            <div className="size-8 rounded-lg flex items-center justify-center shadow-lg shadow-blue-500/20 overflow-hidden">
                                <img 
                                    src={logo}
                                    alt="AgentHub Logo" 
                                    className="w-full h-full object-cover"
                                />
                            </div>
                            <h2 className="text-xl font-bold tracking-tight text-white">AgentHub</h2>
                        </div>
                        <p className="text-sm text-gray-400 leading-relaxed mb-6">
                            El marketplace líder para descubrir, desplegar y escalar agentes de inteligencia artificial en entornos empresariales.
                        </p>
                        <div className="flex gap-4">
                            <a href="#!" className="text-gray-500 hover:text-blue-400 transition-colors" aria-label="Twitter">
                                <i className="fa-brands fa-twitter text-xl"></i>
                            </a>
                            <a href="#!" className="text-gray-500 hover:text-blue-400 transition-colors" aria-label="LinkedIn">
                                <i className="fa-brands fa-linkedin text-xl"></i>
                            </a>
                            <a href="#!" className="text-gray-500 hover:text-blue-400 transition-colors" aria-label="GitHub">
                                <i className="fa-brands fa-github text-xl"></i>
                            </a>
                        </div>
                    </div>

                    {/* Links - Product */}
                    <div>
                        <h3 className="font-semibold text-white mb-4">Producto</h3>
                        <ul className="space-y-3">
                            <li><Link to="/marketplace" className="text-sm text-gray-400 hover:text-blue-400 transition-colors">Marketplace</Link></li>
                            <li><Link to="/precios" className="text-sm text-gray-400 hover:text-blue-400 transition-colors">Precios</Link></li>
                            <li><Link to="/casos-de-uso" className="text-sm text-gray-400 hover:text-blue-400 transition-colors">Casos de Uso</Link></li>
                            <li><Link to="/integraciones" className="text-sm text-gray-400 hover:text-blue-400 transition-colors">Integraciones</Link></li>
                        </ul>
                    </div>

                    {/* Links - resources */}
                    <div>
                        <h3 className="font-semibold text-white mb-4">Recursos</h3>
                        <ul className="space-y-3">
                            <li><Link to="/documentacion" className="text-sm text-gray-400 hover:text-blue-400 transition-colors">Documentación API</Link></li>
                            <li><Link to="/blog" className="text-sm text-gray-400 hover:text-blue-400 transition-colors">Blog</Link></li>
                            <li><Link to="/comunidad" className="text-sm text-gray-400 hover:text-blue-400 transition-colors">Comunidad</Link></li>
                            <li><Link to="/soporte" className="text-sm text-gray-400 hover:text-blue-400 transition-colors">Soporte</Link></li>
                        </ul>
                    </div>

                    {/* Links - Company */}
                    <div>
                        <h3 className="font-semibold text-white mb-4">Empresa</h3>
                        <ul className="space-y-3">
                            <li><Link to="/sobre-nosotros" className="text-sm text-gray-400 hover:text-blue-400 transition-colors">Sobre Nosotros</Link></li>
                            <li><Link to="/empleo" className="text-sm text-gray-400 hover:text-blue-400 transition-colors">Empleo</Link></li>
                            <li><Link to="/privacidad" className="text-sm text-gray-400 hover:text-blue-400 transition-colors">Privacidad</Link></li>
                            <li><Link to="/terminos-legales" className="text-sm text-gray-400 hover:text-blue-400 transition-colors">Términos Legales</Link></li>
                        </ul>
                    </div>
                </div>

                <div className="pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-4">
                    <p className="text-sm text-gray-500">
                        © {new Date().getFullYear()} AgentHub Inc. Todos los derechos reservados.
                    </p>
                    <div className="flex items-center gap-2 text-sm text-gray-500">
                        <span>Estado del sistema:</span>
                        <span className="flex items-center gap-1.5 text-emerald-500 font-medium">
                            <span className="relative flex h-2 w-2">
                                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75"></span>
                                <span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-500"></span>
                            </span>
                            Operativo
                        </span>
                    </div>
                </div>
            </div>
        </footer>
    );
}
